import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faPlus, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import {
    ConfinedSpaceEntryPermit,
    ConfinedSpacePeriodicTest,
    ConfinedSpacePrepHazard,
    FeatureType,
    ListItem,
    RepositoryModal,
} from '../../shared'
import { VoiceTextFieldComponent } from '../../shared/components/voice-text-field/voice-text-field.component'
import { ConfinedSpaceEntryPermitsComponent } from './confined-space-entry-permits.component'

@Component({
    templateUrl: './confined-space-entry-permit.component.html',
    styleUrls: ['./safety-checklist-modal.css'],
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent, VoiceTextFieldComponent],
})
export class ConfinedSpaceEntryPermitComponent extends RepositoryModal<ConfinedSpaceEntryPermit> {
    faPlus = faPlus
    faTrash = faTrash
    faSpinner = faSpinner

    jobList: ListItem<string>[] = []

    protected onInitialized(): void {
        const parent = this.editOptions.initializeParams as ConfinedSpaceEntryPermitsComponent
        this.jobList = [...(parent.activeJobList ?? [])]

        const currentJob = this.target.job
        if (currentJob && !this.jobList.some(j => j.value === currentJob)) {
            this.jobList = [new ListItem(currentJob, parent.jobDisplayForItem(currentJob) || currentJob), ...this.jobList]
        }

        this.target.prepHazards = this.target.prepHazards ?? []
        this.target.periodicTests = this.target.periodicTests ?? []
    }

    get canEdit(): boolean {
        return this.services.authentication.hasFeature([FeatureType.SafetyChecklistEdit])
    }

    addPrepHazard() {
        const row = new ConfinedSpacePrepHazard()
        row.id = crypto.randomUUID()
        row.sortOrder = this.target.prepHazards.length
        this.target.prepHazards.push(row)
    }

    removePrepHazard(index: number) {
        this.target.prepHazards.splice(index, 1)
        this.target.prepHazards.forEach((row, i) => (row.sortOrder = i))
    }

    addPeriodicTest() {
        const row = new ConfinedSpacePeriodicTest()
        row.id = crypto.randomUUID()
        row.sortOrder = this.target.periodicTests.length
        this.target.periodicTests.push(row)
    }

    removePeriodicTest(index: number) {
        this.target.periodicTests.splice(index, 1)
        this.target.periodicTests.forEach((row, i) => (row.sortOrder = i))
    }
}
